// extracted by mini-css-extract-plugin
export default {"medium":"V1PBd","wrapper":"r1A3_"};